const styles = theme => ({
    root: {
        flexGrow: 1
    },
    grow: {
        flexGrow: 1,
    },
    main: {
        marginTop: "50px"
    },
    inputContainer: {
        marginTop: "10px",
    },
    buttonContainer: {
        marginTop: "20px",
        marginBottom: "20px",
    },
});

export default styles;